<section class="user-details center-layout">
  <div class="form-central__content" style="width: 30%">
    <div class="form-central__form item-content">
      <div class="icon-wrapper">
        <svg
          width="92"
          height="92"
          viewBox="0 0 92 92"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_3775_21984)">
            <rect
              x="8"
              y="8"
              width="76.0433"
              height="76.0433"
              rx="38.0217"
              fill="#ED1C25"
            />
            <path
              d="M51.671 46.029L64.8483 32.8517C65.2247 32.4814 65.5242 32.0403 65.7293 31.5537C65.9344 31.0671 66.0411 30.5448 66.0433 30.0168C66.0455 29.4887 65.9432 28.9655 65.7421 28.4772C65.5411 27.989 65.2454 27.5453 64.8721 27.1719C64.4988 26.7985 64.0552 26.5027 63.567 26.3016C63.0788 26.1004 62.5555 25.9979 62.0275 26C61.4995 26.0021 60.9771 26.1087 60.4905 26.3137C60.0039 26.5187 59.5627 26.818 59.1923 27.1944L46.015 40.3717L32.8376 27.1957C32.4662 26.8242 32.0252 26.5296 31.5398 26.3285C31.0545 26.1275 30.5343 26.024 30.009 26.024C29.4836 26.024 28.9635 26.1275 28.4781 26.3285C27.9928 26.5296 27.5518 26.8242 27.1803 27.1957C26.4301 27.9459 26.0086 28.9634 26.0086 30.0244C26.0086 31.0853 26.4301 32.1028 27.1803 32.853L40.3576 46.029L27.1483 59.2384C26.4083 59.9907 25.9956 61.0049 26 62.0601C26.0045 63.1153 26.4257 64.126 27.1719 64.8721C27.9181 65.6182 28.929 66.0391 29.9842 66.0433C31.0394 66.0475 32.0535 65.6345 32.8056 64.8944L46.0136 51.6864L59.1896 64.8624C59.971 65.6437 60.995 66.0344 62.0176 66.0344C63.0403 66.0344 64.0643 65.6437 64.8456 64.8624C65.2173 64.4911 65.5121 64.0503 65.7132 63.565C65.9144 63.0798 66.0179 62.5596 66.0179 62.0344C66.0179 61.5091 65.9144 60.9889 65.7132 60.5037C65.5121 60.0184 65.2173 59.5776 64.8456 59.2064L51.671 46.029Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_3775_21984">
              <rect
                width="91.2"
                height="91.2"
                fill="white"
                transform="translate(0.400391 0.400024)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>

      <div class="mt-3">
        <h3 class="heading__4" style="text-align: center">
          Declined Recurring Payments
        </h3>
        <p style="text-align: center">
          We're sorry you've opted out of recurring payments. If you have any
          concerns or feedback, please contact our customer support team.
        </p>
      </div>

      <div
        class="footer"
        style="margin-top: 3rem; text-align: center; font-size: 12px"
      >
        Powered By:
        <img width="50" src="../../../assets/rexpay/ga.png" />
      </div>
    </div>
  </div>
</section>
